import { createContext, useContext, useEffect, useState } from 'react';
import fetchJson from 'utils/fetchJson';
import { Group } from './types';

export interface Context {
  groups: Array<Group>,
  setGroups: (groups: Array<Group>) => void,
  group: string,
  setGroup: (group: string) => void,
  sub: Array<string>,
  setSub: (sub: Array<string> | ((_s: Array<string>) => Array<string>)) => void,
  search: string,
  setSearch: (search: string) => void,
  isThumbnailView: boolean,
  setIsThumbnailView: (isThumbnailView: boolean | ((_i: boolean) => boolean)) => void,
  _lastListTime: number,
  reload: () => void,
}

const DEFAULTCONTEXT: Context = {
  groups: [],
  setGroups: (_g: Array<Group>) => { },
  group: '',
  setGroup: (_g: string) => { },
  sub: [],
  setSub: (_s: Array<string> | ((_s: Array<string>) => Array<string>)) => { },
  search: '',
  setSearch: (_s: string) => { },
  isThumbnailView: false,
  setIsThumbnailView: (_i: boolean | ((_i: boolean) => boolean)) => { },
  _lastListTime: 0,
  reload: () => { },
};

const FileManagerModalInputDialogContentContext = createContext<Context>(DEFAULTCONTEXT)

export const useFileManagerModalInputDialogContentContext = () => useContext(FileManagerModalInputDialogContentContext);

interface FileManagerModalInputDialogContentProviderProps {
  children: React.ReactNode
}
export const FileManagerModalInputDialogContentProvider = ({ children }: FileManagerModalInputDialogContentProviderProps) => {
  const [groups, setGroups] = useState<Array<Group>>([]);
  const [group, setGroup] = useState('');
  const [search, setSearch] = useState('');
  const [sub, setSub] = useState<Array<string>>([]);
  const [isThumbnailView, setIsThumbnailView] = useState(false);
  const [_lastListTime, set_LastListTime] = useState(Date.now());

  useEffect(() => {
    fetchJson(`/api/file-system/groups`, {})
      .then(x => {
        let allGroups = [{ group: '', label: "[Root]" }, ...x.json.groups];
        setGroups(allGroups);
      })
      .catch(err => {
        console.warn(err)
      });
  }, [])

  const reload = () => {
    set_LastListTime(Date.now());
  }

  return (
    <FileManagerModalInputDialogContentContext.Provider value={{ groups, setGroups, group, setGroup, search, setSearch, sub, setSub, isThumbnailView, setIsThumbnailView, _lastListTime, reload }}>{children}</FileManagerModalInputDialogContentContext.Provider>
  )
}
